module.exports = __webpack_public_path__ + "static/media/stadtticket.411c1db1.svg";